var map = {
	"./beer-mug.svg": "8101",
	"./calendar-check.svg": "df91",
	"./capacity.svg": "2301",
	"./cocktail-martini.svg": "f947",
	"./door-lock.svg": "fdd0",
	"./draft.svg": "65df",
	"./dresscode.svg": "99aff",
	"./euro.svg": "c267",
	"./file-horizontal-image.svg": "2544",
	"./globe.svg": "22b8",
	"./mail.svg": "90e4",
	"./night-club-disco-ball.svg": "932a",
	"./party-confetti.svg": "98bc",
	"./phone.svg": "9855",
	"./profile.svg": "2569",
	"./qr-code.svg": "1ea7",
	"./statistics.svg": "8843",
	"./tag.svg": "6e71",
	"./ticket.svg": "dcd9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "909e";